import { inject, Injectable } from '@angular/core';
import { Language } from './language';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoModal } from '@shared/components/modals/info-modal/info-modal';

@Injectable({
  providedIn: 'root',
})
export class Alert {
  private readonly _language = inject(Language);
  private readonly _modal = inject(NgbModal);

  constructor() {}

  async show({
    isError,
    label,
    size = 'sm',
  }: {
    isError: boolean;
    label: string;
    size?: 'sm' | 'lg' | 'xl';
  }): Promise<void> {
    const text = await this._language.getTranslate(label);
    const modalRef = this._modal.open(InfoModal, {
      centered: true,
      size,
    });
    modalRef.componentInstance.setData({
      message: text,
      color: isError ? 'red' : 'black',
    });
  }
}
